'use client'
import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import {Col, Container, Row} from "react-bootstrap";
import Title from "../Title";
import {text, whites} from "@/styles/globalStyleVars";
import {Img} from "../Img";
import {Swiper, SwiperSlide} from 'swiper/react';
import {Autoplay, Navigation} from "swiper/modules";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SliderNavRight from "../SliderNavRight";
import SliderNavLeft from "../SliderNavLeft";

import {usePathname} from "next/navigation";



const MyComponent = ({id, data}) => {

    const concernData = data?.posts?.list;
    const pathname = usePathname()
    const [offset, setOffset] = useState(0)
    const [itemHeight, setItemHeight] = useState(0)
    useEffect(() => {
        // offset
        setOffset(document.querySelector('.container')?.offsetLeft + 15)
        window.addEventListener('resize', () => {
            setOffset(document.querySelector('.container')?.offsetLeft + 15)
        })

        // set section height
        if (window.innerWidth > 991) {
            setTimeout(() => {
                const featureProjectElement = document.querySelector('.feature-project');

                const getHeight = document.querySelector('.feature-project')?.clientHeight;
                document.querySelector('.feature-project').style.height = getHeight + 'px'
                window.addEventListener('resize', () => {
                    if (featureProjectElement) { // Check if the element exists
                        const getHeight = featureProjectElement.clientHeight;
                        featureProjectElement.style.height = getHeight + 'px';
                    }
                })

                // document.querySelector('.feature-project__left').style.height = document.querySelector('.feature-project__right .swiper-slide-active')?.clientHeight + 'px'

            }, 1000)
        }


    }, [data])



    // console.log('data sis', data)

    return (
        <StyledComponent id={id} offset={offset} className={'feature-project pt-100 pb-100 as-sister-concern'}>
            <Container>
                <Row>
                    <Col sm={12} className={'d-flex slider-nav justify-content-between flex-wrap'}>
                        <Title text={data?.section_data?.subtitle} spancolor={'#FFF'}/>
                        <ul className={'d-flex '}>
                            <li><SliderNavLeft/></li>
                            <li><SliderNavRight/></li>
                        </ul>
                    </Col>
                </Row>

            </Container>
            <Container className={'p-0'} fluid>
                <Row>

                    <Col sm={12} className={'feature-project__right'}>
                            <Swiper loop={true}
                                    spaceBetween={30}
                                    slidesPerView={3}
                                    freeMode={true}
                                    loopAdditionalSlides={2}
                                    speed={900}
                                    navigation={{
                                        prevEl: '.as-sister-concern .go-left',
                                        nextEl: '.as-sister-concern .go-right ',
                                    }}
                                    modules={[Autoplay, Navigation]}

                                    autoplay={false}

                                    breakpoints={{
                                        320: {
                                            slidesPerView: 1,
                                            spaceBetween: 15,
                                        },
                                        550: {
                                            slidesPerView: 2,
                                            spaceBetween: 15,
                                        },
                                        768: {
                                            slidesPerView: 3,
                                            spaceBetween: 30,
                                        },
                                        992: {
                                            slidesPerView: 4,
                                            spaceBetween: 30,
                                        },

                                    }}>
                                {
                                    concernData?.length > 0 &&
                                    concernData.map((element, index) =>
                                        (
                                            <SwiperSlide key={index}>
                                                <div className="feature-project__slider" >
                                                    <a target={"_blank"} href={element?.data?.short_desc}/>
                                                    <div className="feature-project__slider__img">
                                                        <Img src={element?.images?.[1]?.cdn_path}/>
                                                        <p>{element?.data?.description}</p>
                                                        <h4>{element?.data?.title}</h4>
                                                    </div>
                                                    <div className="feature-project__slider__overlay">
                                                        <img src={element?.images?.[0]?.cdn_path} alt=""/>
                                                    </div>
                                                </div>
                                            </SwiperSlide>
                                        )
                                    )
                                }
                                {
                                    concernData?.length < 6 ?
                                        concernData.map((element, index) => (
                                                <SwiperSlide key={index}>
                                                    <div className="feature-project__slider">
                                                        <a target={"_blank"} href={element?.data?.short_desc}/>
                                                        <div className="feature-project__slider__img">
                                                            <Img src={element?.images?.[1]?.cdn_path}/>
                                                            <p>{element?.data?.description}</p>
                                                            <h4>{element?.data?.title}</h4>
                                                        </div>
                                                        <div className="feature-project__slider__overlay">
                                                            <img src={element?.images?.[0]?.cdn_path} alt=""/>
                                                        </div>

                                                    </div>
                                                </SwiperSlide>
                                            )
                                        ) : ''
                                }


                            </Swiper>
                    </Col>
                </Row>
            </Container>
        </StyledComponent>
    );
};

const StyledComponent = styled.section`
    position: relative;
    background-color: #7497AC;
    //height: unset !important;
    //will-change: transform;
    margin-top: -2px;
    overflow-x:hidden ;
    &:after {
        content: '';
        position: absolute;
        bottom: 0;
        width: 100%;
        height: calc(60%);
        background-color: #3C3C3B;
    }

    .slider-nav {
        margin-bottom: 50px;
        align-items: center;
        @media(max-width: 768px){
            .title{
                flex: 0 0 60%;
                margin-bottom: 0;
            }
            ul{
                flex: 0 0 35%;
                justify-content: flex-end;
            }
        }
    }

    .feature-project__right {
        .feature-project__slider {
            position: relative;
            overflow: hidden;


            a {
                position: absolute;
                height: 100%;
                width: 100%;
                z-index: 14;
                top: 0;
                left: 0;
            }

            .add-to-fav {
                position: absolute;
                top: 20px;
                right: 20px;
                cursor: pointer;
                z-index: 2;

                svg {
                    circle, path {
                        transition: .6s ease;
                    }
                }

                &:hover {
                    svg {
                        #Hover {
                            cy: -13px;
                        }

                        #Path_1920 {
                            stroke: ${text};
                        }
                    }
                }
            }

            &__img {
                padding-top: calc(470 / 470 * 100%);
                position: relative;
                overflow: hidden;
                border-radius: 12px;

                &:after {
                    content: '';
                    position: absolute;
                    background-color: rgba(0, 0, 0, 0.05);
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    border-radius: 12px;
                }

                img {
                    transform: scale(1.01);
                    transition: .3s ease;
                    filter: grayscale(0.9);
                }

                p {
                    font-size: 18px;
                    line-height: 24px;
                    color: ${whites};
                    position: absolute;
                    top: 40px;
                    left: 30px;
                    right: 30px;
                    z-index: 4;
                    opacity: 0;
                    transition: 2s ease-in-out;
                    @media(min-width: 1920px){
                        top: 60px;
                        font-size: 20px;
                        line-height: 27px;
                    }
                }

                h4 {
                    font-size: 24px;
                    line-height: 32px;
                    position: absolute;
                    bottom: 40px;
                    left: 30px;
                    right: 30px;
                    z-index: 4;
                    color: ${whites};
                    opacity: 0;
                    @media(min-width: 1920px){
                        font-size: 28px;
                        line-height: 32px;
                        bottom: 60px;
                    }
                    @media(max-width: 768px){
                        font-size: 20px;
                        line-height: 28px;
                    }
                }
            }

            &:hover {
                .feature-project__slider__img {
                    img {
                        transform: scale(1.04);

                    }

                }
            }

            &__overlay {
                position: absolute;
                height: 100%;
                width: 100%;
                z-index: 9;
                background-color: transparent;
                top: 0;
                left: 0;
                padding: 40px;
                display: flex;
                flex-wrap: wrap;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                transition: 0.4s ease;
                border-radius: 12px;

                img {
                    height: 40px;
                }

                p {
                    font-size: 28px;
                    line-height: 36px;

                }
                @media(min-width: 1920px){
                    padding: 60px 40px;
                }
            }
        }

        .swiper-slide {
            transition: all .6s ease;
        }


        @media (min-width: 991px) {
            .swiper-slide-active {
                width: 43% !important;
            }
        }
    }


    .swiper {
        padding-left: ${p => p.offset}px;
    }

    .swiper-slide-active {
        .feature-project__slider__img img {
            opacity: 1;
            filter: grayscale(0);
            
        }
        .feature-project__slider__img p{
            opacity: 1;
        }
        .feature-project__slider__img h4{
            opacity: 1;
        }



        .feature-project__slider__overlay img {
            opacity: 0;
        }

    }


    @media (max-width: 991px) {
        &:after {
            height: 40%;
        }

        .swiper-slide-active {
            .feature-project__slider__img img {
                //opacity: 0 !important;
            }
            .feature-project__slider__img{
                p{
                    opacity: 0;
                }
                h4{
                    opacity: 0;
                }
            }

            .feature-project__slider__overlay img{
                opacity: 1 !important;
            }
        }
    }

    @media (max-width: 767px) {
        //padding-top: 0;
        //padding-bottom: 100px;
        .container-fluid {
            //padding-left: 15px !important;
            padding-right: 15px !important;
        }

        .title {
            width: 100%;
            margin-bottom: 40px;
        }

        .feature-project__slider__overlay {
            p {
                font-size: 18px;
                line-height: 24px;
            }
        }
        
        .swiper{
            padding-right: 60px;
            
        }
    }


`;

export default MyComponent;
